import { mapImageFields } from '@/adapters/common'
import { IPerson } from '@/interfaces/persons'

export function mapPersonFields(item: Directus.Person): IPerson {
  return {
    id: item.id,
    image: mapImageFields(item.image),
    ...item.translations[0],
    postCount: item.posts?.length || 0,
  }
}
